import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import classnames from 'classnames';
import Card from '../../Atoms/Card';
import Checkbox from '../../Atoms/Checkbox';
import ContextualMenu from '../ContextualMenu';
const CONTEXTUAL_MENU_EDIT_OPTION = {
    name: 'Edit',
};
const CONTEXTUAL_MENU_DELETE_OPTION = {
    name: 'Delete',
};
const CONTEXTUAL_MENU_OPTIONS = [
    CONTEXTUAL_MENU_EDIT_OPTION,
    CONTEXTUAL_MENU_DELETE_OPTION,
];
const StyledCard = styled(Card) `
  && {
    display: flex;
    width: 100%;
    padding: 1rem 1.333333333rem;
    background-color: ${({ isSelected }) => (isSelected ? '#ebeef5' : '#fff')};
    justify-content: space-between;
  }

  ${({ isSelected }) => isSelected && css `
    ${StyledLibraryTitle} {
      font-weight: 700;
    }
  `}
`;
const StyledLibraryTitle = styled.p `
  && {
    font-size: 1.1rem;

    ${({ hasExcerpt }) => hasExcerpt && css `
      margin-bottom: 0.25rem;
    `}
  }
`;
const StyledLibraryExcerpt = styled.p `
  word-break: break-word;
`;
const StyledCheckboxAndTitleExcerptBox = styled.div `
  display: inline-flex;
  align-items: flex-start;
  margin-right: 0.834rem;
`;
const StyledCheckbox = styled(Checkbox) `
  margin-right: 0.834rem;
`;
const StyledTitleAndExcerptBox = styled.div `
  p {
    margin: unset;
  }
`;
const StyledContextualMenuContainer = styled.div ``;
const SafelistSummaryItem = ({ className = '', selectedClassName = '', contextMenuClassName = '', checkboxColor, checkboxSelectedColor, onSelectCallback = () => { }, onEdit = () => { }, onDelete = () => { }, summaryItem, isSelected, showContextMenu, }) => {
    const { guid, excerpt, name: title } = summaryItem;
    // On Select Callback
    const handleSelect = () => {
        onSelectCallback(summaryItem);
    };
    const handleContextMenuContainerClick = useCallback((event) => {
        // To avoid propagating the `click` event to the` Card` component and changing
        // the "selected" state by accident.
        event.stopPropagation();
    }, []);
    const handleContextMenuOptionClick = (optionName) => {
        if (optionName === CONTEXTUAL_MENU_EDIT_OPTION.name) {
            onEdit(guid);
        }
        else if (optionName === CONTEXTUAL_MENU_DELETE_OPTION.name) {
            onDelete(guid);
        } // No `else` statement.
    };
    // TODO: Handle missing `summaryItem`.
    if (!summaryItem)
        return null;
    return (React.createElement(StyledCard, { className: classnames(className, { [selectedClassName]: isSelected }), isSelected: isSelected, onClick: handleSelect },
        React.createElement(StyledCheckboxAndTitleExcerptBox, null,
            React.createElement(StyledCheckbox, { color: checkboxColor, colorWhenChecked: checkboxSelectedColor, isChecked: isSelected }),
            React.createElement(StyledTitleAndExcerptBox, null,
                React.createElement(StyledLibraryTitle, { hasExcerpt: !!excerpt }, title),
                React.createElement(StyledLibraryExcerpt, null, excerpt))),
        showContextMenu && (React.createElement(StyledContextualMenuContainer, { onClick: handleContextMenuContainerClick },
            React.createElement(ContextualMenu, { menuClassName: contextMenuClassName, options: CONTEXTUAL_MENU_OPTIONS, onOptionClick: handleContextMenuOptionClick, portalStyle: { transform: 'translateX(-90%)' } })))));
};
export { SafelistSummaryItem };
